<template>
    <post-list apiUrl="POSTS" />
</template>

<script>
import PostList from './PostList.vue';
export default {
    components: {
        PostList
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/js/components/Home.vue?7d2d8618